class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-cart-recommendations-grid]');
    this.limit = Number(this.dataset.limit || 8);
    this.urlTemplate = this.dataset.url;
    this.#load();
  }

  async #load() {
    try {
      const cart = await this.#fetchJSON('/cart.js');
      const itemCount = cart?.item_count || 0;
      if (itemCount === 0) return;

      const inCart = new Set((cart.items || []).map((item) => item.product_id));
      const productIds = [...inCart].slice(0, 4);
      const fetched = await Promise.all(
        productIds.map((id) => this.#fetchJSON(`${this.urlTemplate}&product_id=${id}`))
      );

      const seen = new Set();
      const products = [];
      for (const data of fetched) {
        for (const product of data?.products || []) {
          if (seen.has(product.id) || inCart.has(product.id)) continue;
          if (this.#isPeriphery(product)) continue;
          seen.add(product.id);
          products.push(product);
          if (products.length >= this.limit) break;
        }
        if (products.length >= this.limit) break;
      }

      if (!products.length) return;
      this.#render(products);
    } catch (error) {
      console.error('Cart recommendations error:', error);
    }
  }

  async #fetchJSON(url) {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
  }

  #render(products) {
    this.grid.innerHTML = products.map((product) => this.#card(product)).join('');
    this.hidden = false;
  }

  #card(product) {
    const image = product.featured_image
      ? `<img src="${product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image}" alt="${this.#escape(product.title)}" loading="lazy" width="600" height="600">`
      : '';
    const price = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format((product.price || 0) / 100);
    return `
      <a class="cart-rec__card" href="${this.#escape(product.url)}" aria-label="${this.#escape(product.title)}">
        <div class="cart-rec__media">${image}</div>
        <div class="cart-rec__title">${this.#escape(product.title)}</div>
        <div class="cart-rec__price">${price}</div>
      </a>
    `;
  }

  #escape(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  #isPeriphery(product) {
    const text = `${product.handle || ''} ${product.title || ''}`.toLowerCase();
    return /cosplay|suitcase|nunchaku|knuckle|mask|t-shirt|tshirt|wallet|helmet|baseball|ashtray|camping|pendant|clipboard|mug|bottle|ornament|necklace|phone-case|guitar|skateboard|poker|bracelet|desk|office|outdoor|tent|chair|carbon-fiber-half/.test(text);
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
